import React from 'react'
import {Link} from 'react-router-dom'
import {Container, Row, Col} from 'react-bootstrap'
import { FaFacebookF,FaInstagram,FaLinkedinIn,FaYoutube,FaTwitter } from "react-icons/fa";
import creditCard from "../images/credit-card.webp"

function Footer() {
    return (
        <Container className="border-top border-2 border-dark mt-3">
           <Row className=" py-3">
           
             <Col md={6} lg={8} className="my-3">
                <ul className="footer-links p-0 d-flex flex-wrap h-75">
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Home </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>About Valetar </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>About </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Contacts </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Help And Support </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Terms And Policies </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Prohibited Items </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Resolution Center </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Selling </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Legal </small></Link>
                    <Link className="text-decoration-none  text-dark fw-bold"  style={{minWidth:"160px"}} to="/"><small>Follow Us </small></Link>
                </ul>
            </Col>
            <Col md={4} className=" d-flex flex-md-column align-items-center my-3 justify-content-between">
                <ul className="p-0 ">
                    <FaFacebookF as='li' className="text-dark fs-4 mx-2 d-inline-block"/>
                    <FaInstagram as='li' className="text-dark fs-4 mx-2 d-inline-block"/>
                    <FaTwitter as='li' className="text-dark fs-4 mx-2 d-inline-block"/>
                    <FaLinkedinIn as='li' className="text-dark fs-4 mx-2 d-inline-block"/>
                    <FaYoutube as='li' className="text-dark fs-4 mx-2 d-inline-block"/> 
                </ul>
                <img src={creditCard} alt="" srcset="" />
            
            </Col>
            </Row> 
            <Col md={10} className="me-auto">
                <p className="text-justify pb-5"><small>
Copyright Valetar Corporation, Logos, Trademarks, Icons, used in listings
and on pages are property of respective owners:
If you noticed any abuse of user or consumer or copyright abuse please contact us immediately: 
 </small> <span className="fw-bold fs-6">89 Minas Avetisyan St, Yerevan, Armenia</span></p>

</Col>
          
            
        </Container>
    )
}

export default Footer
